cv.PayCompleteView = Marionette.LayoutView.extend({
  className: 'view-pay-complete',

  template: cv.Templates['pay/complete/pay_complete'],

  regions: {
  },

  behaviors: [{
    behaviorClass: cv.ShareBehavior
  }],

  events: {
    'click .redirect-url' : 'redirectURL'
  },

  initialize: function(options){
    this.options = _.extend(this.options, options);

    console.log('PayCompleteView initialized');
  },

  templateHelpers: function () {
    return {
      email : cv.pay.get('email'),
      total : accounting.toFixed(accounting.unformat(+cv.pay.get('amount') + +cv.pay.get('tip')), 2) + ' ' + cv.campaign.get('currency_code'),
      has_post_donation_text: cv.campaign.get('post_donation_text') != '' ? true : false,
      post_donation_text : cv.campaign.get('post_donation_text'),
      has_redirect_url : cv.campaign.get('redirect_url') != '' && cv.campaign.get('type') == 'donation' ? true : false,
      redirect_url : cv.campaign.get('redirect_url'),
      campaign_url : cv.campaign.get('url')
    };
  },

  redirectURL: function(e){
    e.preventDefault();

    top.location = cv.campaign.get('redirect_url');
  },

  onAttach: function(){
    // Pixel tracking stuff
    if(parseInt(cv.campaign.get('enable_fb_tracking'), 10) == 1 && cv.campaign.get('fb_tracking_code') != ''){
      console.log('Tracking FB purchase event...');
      fbq('track', 'Purchase', {
        value : +cv.pay.get('amount') + +cv.pay.get('tip'),
        currency : cv.campaign.get('currency_code')
      });
    }
  },

  onShow: function(){
  }
});
